import React, { useEffect } from "react";
import { Button } from "../components/button/button";
import { Header } from "../components/header/header";
import { Search } from "../components/search/search";
import edit from "../img/edit.svg";
import "../styles/addDc.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../auth/axiosInstance";
import ModalEdit from "../components/modalEdit/modalEdit";
import { Input } from "../components/input/input";
import user from "../img/user.svg";
import ModalConfirm from "../components/ModalConfirm/ModalConfirm";
import ModalSucesso from "../components/ModalSucesso/index";
import FooterStatus from "../components/footerStatus/footerStatus";
import { useStore } from "../store/useStore";
import RackDetails from "../components/viewRacksDetails/rackDetails";

function Client({ type }) {
  const navigate = useNavigate();
  const [showEdit, setShowEdit] = React.useState(false);
  const [editText, setEditText] = React.useState(false);
  const [values, setValues] = React.useState({});
  const [openModalRemoveClient, setOpenModalRemoveClient] = React.useState(false);
  const [tipo, setTipo] = React.useState(false);
  const [status, setStatus] = React.useState(false);
  const [valuesEdit, setValuesEdit] = React.useState({});
  const [content, setContent] = React.useState("");
  const [showFeedback, setShowFeedback] = React.useState(false);
  const { clientsData, fetchData, siteData } = useStore()
  const [initialData, setInitialData] = React.useState(clientsData)
  const [localVar, setLocalVar] = React.useState(clientsData);
  const [clientRacks, setClientRacks] = React.useState({})
  const [siteSelected, setSiteSelected] = React.useState('')

  useEffect(() => {
    setInitialData(clientsData)
    setLocalVar(clientsData)
  }, [clientsData])

  useEffect(() => {
    if (!showEdit && !editText) {
      setValues({})
      setValuesEdit({})
    }
  }, [showEdit, editText])

  const onChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const onChangeEdit = (event) => {
    setValuesEdit({ ...valuesEdit, [event.target.name]: event.target.value });
  };

  async function newClient(e, values) {
    e.preventDefault();
    await axiosInstance
      .post(`clients`, values)
      .then((res) => {
        if (res.status === 201) {
          fetchData('clients/rack', 'clientsData')

          let obj = {
            client: res.data.client,
            clientSites: [{}],
            count: [{}],
            createdAt: res.data.createdAt,
            id: res.data.id,
            updatedAt: res.data.updatedAt,
          }

          setValuesEdit(obj)
          setValues(res.data);
          setEditText(true)
          setShowEdit(false)
          setTimeout(() => {
            setShowFeedback(false);
          }, 10000);
          setShowFeedback(true)
          setContent("Client created successfully");
        }
      })
      .catch((err) => {
        console.log(err);
        var error = err.response.status;
        setTipo(false);
        setContent(`Error on creating client, code error: ${error}`);
        setStatus(true);
      });
  }

  async function putClient(e) {
    e.preventDefault();
    await axiosInstance
      .patch(`clients/${valuesEdit.id}`, { client: valuesEdit.client })
      .then((res) => {
        if (res.status === 200) {
          fetchData('clients/rack', 'clientsData')
          setEditText(false)
          setContent("Updated client successfully");
          setShowFeedback(true);
          setTimeout(() => {
            setShowFeedback(false);
          }, 10000);
        }
      })
      .catch((err) => {
        console.log(err);
        var error = err.response.status;
        setContent(`Error on updating client, code error: ${error}`);
        setTipo(false);
        setStatus(true);
      });
  }

  async function delClient(e) {
    e.preventDefault();
    await axiosInstance
      .delete(`clients/${valuesEdit.id}`)
      .then((res) => {
        if (res.status === 200) {
          fetchData('clients/rack', 'clientsData')
          openModal(false);
          setTimeout(() => {
            setShowFeedback(false);
          }, 10000);
          setValues({});
          setShowEdit(false);
          setContent("Deleted client successfully");
          setShowFeedback(true);
        }
      })
      .catch((err) => {
        console.log(err);
        var error = err.response.status;
        setContent(`Error on deleting client, code error: ${error}`);
        setTipo(false);
        setStatus(true);
      });
  }

  const addOrRemoveSiteChecked = (e, siteId) => {
    const id = valuesEdit.id
    if (id && siteId) {
      if (e.target.checked) {
        axiosInstance
          .post(`clients-sites`, {
            site_id: siteId,
            client_id: id,
          })
          .then(res => {
            fetchData('clients/rack', 'clientsData')
            const val = res.data.find(el => el.client.id === valuesEdit.id)
            setValues(val)
            setContent("Data Center added successfully");
          })
          .catch(err => {
            console.log(err)
            setContent(`Error on added link with client and site`);
          })
      }
      else {
        axiosInstance.delete(`clients-sites`, {
          data: {
            site_id: siteId,
            client_id: id,
          }
        }).then(res => {
          fetchData('clients/rack', 'clientsData')
          const val = res.data.find(el => el.client.id === valuesEdit.id)
          setValues(val)
          setContent("Data Center Removed successfully");
        }).catch(err => {
          console.log(err)
          setContent(`Error on deleting link with client and site`);
        })
      }
    }
  };

  function openModal(status) {
    setOpenModalRemoveClient(status);
  }

  return (
    <section className="control-body">
      {Object.keys(clientRacks).length > 0 && <RackDetails close={() => setClientRacks({})} data={clientRacks} />}
      <Header line>
        <h1 style={{paddingBottom:'12px', fontSize:'2rem'}}>
          Clients
        </h1>
      </Header>

      <div className="search-area">
        <Search
          initialData={initialData}
          set={setLocalVar}
          style={{
            border: "1px solid #0F0742",
            boxShadow: "0 0 0",
            width: type !== 'View Only' ? "75%" : "100%",
          }}
          placeholder="Search Client"
        />

        {type !== 'View Only' && <Button
          style={{ width: "30%", background: "#0F0742", color: "#fff" }}
          onClick={() => {
            setShowEdit(true);
            return setEditText(false);
          }}
          label={"New Client"}
          icon={user}
        />}
      </div>
      
      <h1 className="title-totalracks">Total Clients ({localVar?.length})</h1>
      <section className="table-estructure-rack">
        {localVar?.map((value) => {
          if(value.clientName == "AVAILABLE RACK") {
            <></>
          } else {
            return (
              <div className="row-table-estructure">
                <div style={{ width: "30%" }} className="column-table-estructure">
                  <h1>Name</h1>
                  <h3>{value.client.client}</h3>
                </div>
                <div style={{ width: "25%" }} className="column-table-estructure">
                  <h1>Racks By Site</h1>
                  {value.sites.length > 0 ? (
                    <div className="list-rooms-table-dc">
                      {value.sites.map((site, i) => {
                        return (
                          <div
                            key={i}
                            className="style-list-room-table-client"
                          >
                            {site.siteName} | <b>{site.totalRacks} Racks</b>
                          </div>
                        )
                      })}
                    </div>
                  ) : (
                    <h3>No Data</h3>
                  )}
                </div>
                <div style={{ width: "35%" }} className="column-table-estructure">
                  <h1>Sites</h1>
                  {value.clientsSites.length > 0 ? (
                    <div className="list-rooms-table-dc">
                      {value.clientsSites.map((site, i) => {
                        return (
                          <div
                            key={i}
                            className="style-list-room-table-client"
                          >
                            {site.site.site}
                          </div>
                        )
                      })}
                    </div>
                  ) : (
                    <h3>No Data</h3>
                  )}
                </div>

                <div className="content-view-room">
                  {type !== 'View Only' && <img
                    onClick={() => {
                      setEditText(true);
                      return setValuesEdit(value.client)
                    }}
                    src={edit}
                    alt="edit"
                  />}
                  <Button disabled={value.sites.length < 1} onClick={() => setClientRacks(value)} label='Racks Details' />
                </div>
              </div>
            );
          }
          
        })}
      </section>
      <ModalEdit
        show={showEdit || editText}
        deletar={() => {
          openModal(true);
        }}
        hidenDelete={true}
        close={() => (
          setValues({}), setEditText(false), setShowEdit(false)
        )}
        label={`${editText
          ? "Insert the information below to edit a Client"
          : "Insert the information below to register a new client"
          }`}
        title={`${editText ? "Edit Client" : "New Client"}`}
        labelButton={`${editText ? "Edit" : "Add"}`}
        iconButton={user}
        function={editText ? (e) => putClient(e) : (e) => newClient(e, values)}
        trash={editText ? { display: "flex" } : { display: "none" }}
      >
        <div className="search-e-res">
          <Input
            onChange={editText ? onChangeEdit : onChange}
            name="client"
            placeholder='Insert Here'
            required
            value={editText ? Object.keys(valuesEdit).length > 0 && valuesEdit.client : values.client}
            title="Client Name"
          />

          <div className="searchselect-editmodal">
            <h1>Insert Sites:</h1>
            {!editText && !values.id && <h4 style={{ fontSize: 12, fontWeight: 300 }}>(Please add a client using the button above first)</h4>}
            <div className="search-linkcs" style={{ marginTop: "10px" }}>
              <div className="sites-select">
                {siteData?.map((value) => {
                  return (
                    <div className="sites-select-inside">
                      <div className="sites-select-value ">
                        <input
                          className="checkedClear"
                          type="checkbox"
                          id={`site-${value.id}`}
                          name={`site-${value.id}`}
                          disabled={!editText && !values.id}
                          checked={values?.clientsSites?.some(el => el.site?.id == value.id)}
                          onClick={(e) => addOrRemoveSiteChecked(e, value?.id)}

                        />
                        <h1>{value.site}</h1>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>        

        </div>
      </ModalEdit>

      <div
        style={
          openModalRemoveClient ? { display: "flex" } : { display: "none" }
        }
      >
        <ModalConfirm
          yes={(e) => delClient(e)}
          no={() => openModal(false)}
          content={"Are you sure you want to delete this costumer?"}
        />
      </div>

      <ModalSucesso
        tipo={tipo}
        status={status}
        content={content}
        ok={() => setStatus(false)}
      />

      <FooterStatus
        show={showFeedback}
        text={content}
        cancel={() => setShowFeedback(false)}
      />

    </section>
  );
}

export default Client;
